import { createDeleteAsyncSlice } from '@sonar-software/xuder';
import { deleteInitiativesUnsyncJira } from '@api';
import { initiativesJiraIssueUpdateSlice } from '../../@sync/update';
import { InitiativeSyncJiraIssueName } from '../name';

export const deleteInitiativesUnsyncJiraSlice = createDeleteAsyncSlice({
	httpSagaOptions: {
		preRequestActionCreators: [
			() => initiativesJiraIssueUpdateSlice.syncActionCreator({
				issueKey: ''
			})
		]
	},
	name: InitiativeSyncJiraIssueName,
	receive: false,
	request: true,
	requestHandler: deleteInitiativesUnsyncJira
});
